"use strict";

var _classCallCheck = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @ts-ignore: Could not find a declaration file for module

var schema_inspector_1 = require("schema-inspector");

var profileTokens_1 = require("../profileTokens");

var profile_1 = require("../profile");

var schemaDefinition = {
  type: 'object',
  properties: {
    '@context': {
      type: 'string',
      optional: true
    },
    '@type': {
      type: 'string'
    },
    '@id': {
      type: 'string',
      optional: true
    }
  }
};
/**
 * @ignore
 */

var CreativeWork =
/*#__PURE__*/
function (_profile_1$Profile) {
  _inherits(CreativeWork, _profile_1$Profile);

  function CreativeWork() {
    var _this;

    var profile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CreativeWork);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CreativeWork).call(this, profile));
    _this._profile = Object.assign({}, {
      '@type': 'CreativeWork'
    }, _this._profile);
    return _this;
  }
  /**
   *
   * @ignore
   */


  _createClass(CreativeWork, null, [{
    key: "validateSchema",
    value: function validateSchema(profile) {
      var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      schemaDefinition.strict = strict;
      return schema_inspector_1.default.validate(schemaDefinition, profile);
    }
    /**
     * @ignore
     */

  }, {
    key: "fromToken",
    value: function fromToken(token) {
      var publicKeyOrAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var profile = profileTokens_1.extractProfile(token, publicKeyOrAddress);
      return new CreativeWork(profile);
    }
  }]);

  return CreativeWork;
}(profile_1.Profile);

exports.CreativeWork = CreativeWork;